import { App } from '@capacitor/app';

export class CapacitorApp {
  /**
   * Hardware back button policy: navigate web history when possible,
   * otherwise do nothing. Without a listener, Capacitor's default
   * OnBackPressedCallback minimizes/closes the app once webview history
   * is exhausted — this enforces "never exit at root".
   */
  static initBackButton() {
    App.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) window.history.back();
    });
  }
}
